export default {"src":"/_next/static/media/0xb73603c5d87fa094b7314c74ace2e64d165016fb.6f7cbaef.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};